'use client'
import { useActionState, useEffect, useState } from "react";
import { ColorButton } from "./button";
import { CheckboxInput } from "./checkboxInput";
import { H2 } from "./h";
import { TextInput } from "./textInput";
import Form from "next/form";
import { confimPassword } from "@/app/api";
import { useRouter } from "next/navigation";

type ConfirmPasswordProps = {
    name: string,
    user: string,
    message: string,
    onClose: () => void
}

export function ConfirmPassword({ name, user, message, onClose }: ConfirmPasswordProps) {
    const router = useRouter();
    const [showPass, setShowPass] = useState<boolean>(false)

    const [state, formAction, pending] = useActionState(confimPassword, {
        values: { identifier: user, password: '' },
        errors: {},
        message: '',
    })

    if (state.success) setTimeout(() => onClose(), 100);

    useEffect(() => {
        if (state.message || state.errors?.password || state.errors) {
            setShowPass(false);
        }
    }, [state]);
    return (
        <Form action={formAction}>
            <div className={`fixed flex flex-col p-4 gap-6 
                    top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-30 rounded-md shadow-lg bg-silver-100 dark:bg-silver-500`}>

                <div className="flex flex-col p-4 gap-3 justify-center items-center">

                    <input type="hidden" name="user" defaultValue={user} required />

                    <div className="flex flex-col gap-2">
                        <p></p>
                        <H2>{name}</H2>
                        <p>{message}</p>

                        {/* password */}

                        <TextInput placeholder="Senha" name="password" type={showPass ? "text" : "password"} minLength={6}
                            defaultValue={state?.values?.password} />

                        {/* visualizar senha */}

                        <div className="flex items-center gap-2 text-sm">
                            <CheckboxInput name="showPassword" id="showPassword" onClick={() => { setShowPass(showPass ? false : true) }} />
                            Mostrar senha
                        </div>
                        <p className="font-medium text-red-500">{state.message}</p>

                    </div>
                    <div className="flex p-2 gap-10">
                        <ColorButton type="button" onClick={() => { router.back() }}>
                            Cancelar
                        </ColorButton>

                        <ColorButton type="submit" disabled={pending}>
                            {pending
                                ? 'Confirmando...'
                                : 'Confirmar'}
                        </ColorButton>
                    </div>
                </div>
            </div>
            <div className="fixed w-screen h-screen top-0 left-0 z-10 bg-black/10" />
        </Form>
    )
}